export type TOptional<T> = T | undefined;

export type TNullable<T> = T | null;

export type TKeysOf<T> = keyof T;

export type TSortConditions<T> = Partial<Record<TKeysOf<T>, 1 | -1>>;
